import styled from 'styled-components';

export const BGWrap = styled.div`
  width: 100%;
  padding-top: ${({ width, height }) => `${(height / width) * 100}%`};
  border-top: none;
  border-bottom: none;
  box-sizing: border-box;
  background: url(${({ imgUrl }) => imgUrl}) center center no-repeat;
  background-size: cover;
  position: relative;
`;

export const CleanSignUpBtn = styled.button`
  border: none;
  box-sizing: border-box;
  background: transparent;
  position: absolute;
  width: 78.31%;
  top: 35.8%;
  left: 10.845%;
  height: 2.8%;
`;

export const ClosetStoreBtn = styled.button`
  border: none;
  box-sizing: border-box;
  background: transparent;
  position: absolute;
  width: 78.31%;
  top: 83%;
  left: 10.845%;
  height: 2.8%;
`;

export const CheckGroupBG = styled.div`
  padding: 16px;
  background-color: #D9EDF7;
`;
